<template>
  <v-container id="contact-detail" fluid tag="section">
    <!-- <CommonLoadingInfinity v-if="loadingRouter" /> -->
    <base-material-card v-if="loadContactDetailSuccess && !loadingRouter" icon="mdi-account-outline" class="overflow-visible pb-0 mt-0">
      <template v-slot:after-heading>
        <div class="header">
          <div class="font-weight-light card-title mt-2">Tạo đơn hàng</div>
        </div>
      </template>
      <validation-observer ref="validator" v-slot="{ handleSubmit }">
        <div style="position: relative">
          <div class="header-group-btn">
            <v-menu offset-y v-if="dataForm.contactType == 'main'">
                  <template v-slot:activator="{ on: on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="info" class="mb-2">
                      <v-icon>mdi-phone</v-icon>Gọi điện
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      @click="clickExecuteCall(dataForm, dataForm.customers[0].mobile)"
                      class="main-mobile"
                    >
                      <v-list-item-title>{{dataForm.customers[0].mobile}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-for="(phone, index) in dataForm.phoneRelated"
                      :key="index"
                      @click="clickExecuteCall(dataForm, phone)"
                      class="sub-mobile"
                    >
                      <v-list-item-title>{{phone}}</v-list-item-title>
                    </v-list-item>
                  </v-list>
            </v-menu>
            <v-btn @click="clickExecuteCall(dataContact, phone)" v-else color="info" class="mb-2">
              <v-icon>mdi-phone</v-icon>Gọi điện
            </v-btn>
          </div>
        </div>
        <v-row class="px-3" :class="stepOrder===3 ? 'active-step-3' : ''">
          <v-col v-if="stepOrder == 1" cols="12" sm="12" class="py-0">
            <customer-card
              :childCustomers="childCustomers"
              :dataForm="dataForm"
              :provinces="provinces"
              :stepOrder="stepOrder"
              :showChat="showChat"
            />
          </v-col>
          <v-col v-if="stepOrder > 1" class="pb-0" cols="12" :md="stepOrder === 2 ? 8 : 10">
            <order-card
              :shippingAddress="shippingAddress"
              :contactStatusList="contactStatusList"
              :contentOrder="contentOrder"
              :courseRegisters="courseRegisters"
              :childCustomers="childCustomers"
              :stepOrder="stepOrder"
              :showChat="showChat"
              ref="child"
              :mode="'create'"
            />
          </v-col>
          <v-col v-if="stepOrder === 2" cols="12" md="4" class="pb-0">
            <address-card
              :shippingAddress="shippingAddress"
              :provinces="provinces"
              :showChat="showChat"
              :contentOrder="contentOrder"/>
            <template v-if="typeSystem  && isCheckIeltsY_T || isCheckIeltsY_GS && typeSystem">
              <validation-provider v-slot="{ errors }" name="Trường đã chọn">
                <v-autocomplete
                    v-model="schoolId"
                    :items="listSchool"
                    item-text="school_name"
                    item-value="id"
                    clearable
                    label="Trường đã chọn"
                    :error-messages="errors"
                />
              </validation-provider>
            </template>
          </v-col>
          <!-- <v-col cols="12" sm="12" style="text-align: center;" v-if="!checkIncludesT4NT5(dataForm.contactStatus.type)"> -->
          <v-col cols="12" sm="12" style="text-align: center;">
            <!-- <v-btn
              v-if="stepOrder === 2"
              color="default"
              class="mb-3"
              @click="stepOrder = stepOrder -1"
            >Quay lại</v-btn> -->
            <v-btn
              v-if="stepOrder === 2"
              color="default"
              class="mb-3"
              @click="backToPrevStep"
            >Quay lại</v-btn>
            <v-btn
              v-else
              color="success"
              class="mb-3"
              @click.prevent="handleSubmit(clickStep)"
            >Tiếp Theo</v-btn>
            <v-btn
              v-if="stepOrder === 2 && checkAuthorization('order_create')"
              color="success"
              class="mb-3"
              @click.prevent="handleSubmit(beforeCreate); scrollToError('v-messages__message', 'order-products-wrapper')"
            >Tạo đơn</v-btn>
            <v-btn color="primary" class="mb-3" @click="clickCancel">Huỷ Bỏ</v-btn>
          </v-col>
        </v-row>
      </validation-observer>
    </base-material-card>

    <order-dialog
      :loading="loadingCreateOrder"
      :dialog="createDialog"
      :courseRegisters="courseRegisters"
      :childCustomers="childCustomers"
      @closeModal="closeModal"
      :dataDialog="dataDialog"
      :provinces="provinces"
      :checkEndDate="checkEndDate"
      :listProductLearnType="listProductLearnType"
      @orderAction="clickCreateOrder"/>
  </v-container>
</template>

<script>
import TokenService from '../../helpers/token';
import { moduleTypes } from '../../helpers/constants';
import CustomerCard from './components/CustomerCard';
import AddressCard from './components/AddressCard';
import OrderCard from './components/OrderCard';
import OrderDialog from './components/OrderDialog';
import { showFbMessengerIcon } from '@/helpers/utils'
import RepositoryFactory from '../../repositories/RepositoryFactory';
import { moduleSchoolLevel } from '@/helpers/constants';
import * as moment from 'moment'
const ContactRepository = RepositoryFactory.get('contact');
const ProductRepository = RepositoryFactory.get('product');
const ContactStatusRepository = RepositoryFactory.get('contact_status');
const AddressRepository = RepositoryFactory.get('address');
const OrderRepository = RepositoryFactory.get('order');
const SchoolRepository = RepositoryFactory.get('school');

export default {
  components: { CustomerCard, AddressCard, OrderCard, OrderDialog },
  data() {
    return {
      listProductLearnType: [],
      showConfirm: false,
      mobile: '',
      // showModalCall: false,
      appointmentId: '',
      courseRegisters: [],
      dataForm: {
        customers: [{}]
      },
      dataFormOld: '',
      mainCustomer: {},
      stepOrder: 1,
      firstStep: false,
      provinces: [],
      contactStatusList: [],
      shippingAddress: {
        xaName: '',
        tinhName: '',
        huyenName: '',
        receiver: '',
        phone: '',
        email: '',
        tinhId: 0,
        xaid: 0,
        huyenId: 0,
        detailAddress: ''
      },
      contentOrder: {
        paidAmount: 0,
        totalPrice: 0,
        products: [
          {
            productId: '',
            quantity: 1,
            price: 0,
            customerId: '',
            intoMoney: 0,
            productType: this.$store.state.module.typeId && [moduleTypes.GIA_SU, moduleTypes.IELTS_Y].includes(this.$store.state.module.typeId) ? 'GIA_SU' : 'THUONG',
            product: {
              monCode: '',
              teacherType: '',
            },
            orderType: this.$store.state.module.typeId && this.$store.state.module.typeId == 2? '' : null,
            listActiveType: [],
            activeType: [],
            activeTypeOrder: '',
            activeDate: null,
          }
        ],
        description: '', //ghi chu don hang,
        paymentType: '',
        noteSortClass: '',
      },
      loadContactDetailSuccess: false,
      showChat: false,
      dataUpdate: {},
      dataDialog: {},
      createDialog: false,
      checkEndDate: true,
      loadingCreateOrder: false,
      schoolId: '',
      listSchool: [],
      attrs: [
        'id',
        'school_name',
        'school_code'
      ],
     isCheckIeltsY_GS: false,
     isCheckIeltsY_T: false,
     moduleTypes,
     moduleSchoolLevel,
     versionUser: null,
     loadingRouter: false,
    };
  },
  computed: {
    typeSystem() {
      return this.$store.state.module.typeId == 6 && this.$store.state.module.schoolLevelId == 7
    },
    childCustomers() {
      return (
        this.dataForm.customers.filter(
          customer =>
            customer.position === 'child' &&
            !_.get(customer, 'isDeleted', false)
        ) || [{}]
      );
    },
    moduleschoolLevelId() {
      return this.$store.state.module.schoolLevelId
    }
  },
   async created() {
    // OMS 438 Redirect from new UI
    this.loading = this.$loading.show();
    this.loadingRouter = true
    await this.checkVersionUser()
    const oldVersion = this.$route.query.oldVersion;
    if (this.versionUser && Number(this.versionUser) !== 1 && !this.$route.query.oldVersion) {
      this.$router.push(
        {name: 'UpdateContactInfo', params: { id: this.$route.params.id }}
      );
      this.loading.hide();
    } else {
      this.loadingRouter = false
      this.loading.hide();
    }
    if (this.$route.query && this.$route.query.step) {
      this.stepOrder = parseInt(this.$route.query.step);
      this.getContactAddress();
    }
    this.getContactDetail();
    this.getProvinces();
    this.getProductComboList();
    if(this.typeSystem) { //check nếu là ielts y
      this.getListSchool()
    }
     Bus.$on('checkIeltsY-GS', (data) => {
       this.isCheckIeltsY_GS = data
     });
     Bus.$on('checkIeltsY-T', (data) => {
       this.isCheckIeltsY_T = data
     });
    Bus.$on('order-back-step', () => {
      --this.stepOrder;
    });
    Bus.$on('order-step', () => {
      this.clickStep();
    });
  },
  beforeDestroy() {
    Bus.$off('order-back-step');
    Bus.$off('order-step');
    Bus.$off('checkIeltsY-GS')
    Bus.$off('checkIeltsY-T')
  },
  methods: {
    async getContactAddress() {
      const params = {
        contactId: this.$route.params.id,
        page: 0,
        limit: 1,
      };
      const res = await ContactRepository.getContactAddress(params);
      if (res.data && res.data.length) {
        Object.assign(this.shippingAddress, {
          receiver: res.data[0].receiverName,
          phone: res.data[0].phone,
          email: '',
          tinhId: res.data[0].provinceId,
          huyenId: res.data[0].districtId,
          xaId: res.data[0].wardId,
          detailAddress: res.data[0].detailAddress,
        });
      }
    },
    formatDateVN(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY');
      }
      return '';
    },
    attrsDataUrl(dataRequest) {
      let data = "";
      dataRequest.forEach((item) => {
        data += "&attrs[]=" + item;
      });
      return data;
    },
    async getListSchool() {
      const filter = { limit: 1000 , 'filters[$eq__status]': 1 }
      if([this.moduleSchoolLevel.STATION,this.moduleSchoolLevel.SCHOOL].includes(this.moduleschoolLevelId)) {
        filter[`filters[$eq__type]`] = this.moduleschoolLevelId === this.moduleSchoolLevel.STATION ? 'station' : 'school'
      }
      const respond =await SchoolRepository.listSchoolApi(this.attrsDataUrl(this.attrs),filter);
      if(respond.success){
        this.listSchool = _.get(respond, 'data', [])
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },

    clickCancel() {
      this.$router.push({
        name: 'ContactOrderList',
        params: {
          id: this.$route.params.id || 0
        }
      });
    },
    clickExecuteCall(dataContact, phone) {
      const data = {
        mobile: phone,
        showCreateAppointment: false,
        contactId: dataContact.id,
        mainId: dataContact.mainId,
        mainMobile: dataContact.mobile
      }
      Bus.$emit('voice-call-show-popup', data)
    },
    async clickCreateOrder() {
      this.closeModal()
      // Combine the same products and customers
      this.loading = this.$loading.show();
      this.loadingCreateOrder = true;
      // delete this.dataUpdate.listEndDate;
      let response
      if(this.$refs.child.statusDepositOne || this.$refs.child.statusDepositTwo) {
        this.dataUpdate.totalPrice = this.$refs.child.restPrice
        this.dataUpdate.orderType = 1
        this.dataUpdate.totalPriceOfGroup = (this.$refs.child.totalPriceT + this.$refs.child.totalPriceGS)
        if(this.$refs.child.statusDepositTwo) {
           this.dataUpdate.trailProduct = this.$refs.child.orderHT.map(s => {
            return {
              trailLessons: Number(s.quantity),
              productId: s.id,
              money: s.intoMoney,
              customerId: s.customerId,
              numberOfSection: s.numberOfSection,
            }
          })
        }
        response = await OrderRepository.createV2(this.dataUpdate);
      }else {
        response = await OrderRepository.createV2(this.dataUpdate);
      }
      this.loading.hide();
      this.loadingCreateOrder = false;
      if (response.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      } else if (_.get(response, 'data.isExist', false)) {
        this.$swal({
          title: 'Thêm mới đơn hàng không thành công, Số điện thoại người nhận đã tồn tại!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Xem contact',
          closeOnConfirm: false,
          cancelButtonText: 'Huỷ Bỏ'
        }).then(result => {
          if (result.value) {
            return this.$router.push({
              name: 'ContactDetail',
              params: {
                id: _.get(response, 'data.contactId', null)
              }
            });
          }
        });
      } else {
        this.$swal({
          title: 'Tạo Đơn hàng thành công!',
          confirmButtonText: 'Đồng ý'
        }).then(() => {
          this.$router.push({
            name: 'ContactOrderList',
            params: {
              id: this.$route.params.id
            }
          });
        });
      }
    },
    async getProvinces() {
      const respond = await AddressRepository.provinces({ limit: 100 });
      if (_.get(respond, 'success', false)) {
        this.provinces = _.get(respond, 'data', []).filter(
          data => data.id != 0
        );
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getContactDetail() {
      const loader = this.$loading.show();
      const respond = await ContactRepository.detail(this.$route.params.id);
      loader.hide();
      if (_.get(respond, 'success', false) && _.get(respond, 'data', null)) {
        this.loadContactDetailSuccess = true
        const dataContact = _.get(respond, 'data', {});
        const contactSourceIds = _.get(dataContact, 'contactSources', []).map(
          contactSource => contactSource.id
        );
        showFbMessengerIcon(_.get(dataContact, 'contactSources', []).map(contactSource => contactSource.name))
        const groupIds = [];
        if (!Array.isArray(dataContact.customers)) {
          dataContact.customers = [];
        }
        const customers = dataContact.customers.map(customer => {
          const customerTemp = customer;
          customerTemp.customerId = customerTemp.id;
          customerTemp.phones = _.get(customer, 'phones', []).map(
            data => data.phoneNumber
          );
          customerTemp.courseRegister = [];
          customerTemp.combos.forEach(combo => {
            customerTemp.courseRegister.push(`combo-${combo.id}`);
            _.get(combo, 'products', []).forEach(product => {
              if (
                _.get(product, 'group.id', null) &&
                !groupIds.includes(product.group.id)
              )
                groupIds.push(product.group.id);
            });
          });
          customerTemp.products.forEach(product => {
            customerTemp.courseRegister.push(`product-${product.id}`);
            if (
              _.get(product, 'group.id', null) &&
              !groupIds.includes(product.group.id)
            )
              groupIds.push(product.group.id);
          });

          if (!_.get(customer, 'isMainCustomer', false)) {
            if (!Array.isArray(customerTemp.phones)) {
              customerTemp.phones = [];
            }
            customerTemp.mobile = _.get(customerTemp, 'phones[0]', '');
            customerTemp.phones.shift();
          }

          customerTemp.isNew = false;

          if (customer.isMainCustomer && customer.fullName === '') {
            customerTemp.fullName = customerTemp.mobile;
          }

          return customerTemp;
        });

        const mainCustomer = customers.find(
          customer => customer.isMainCustomer
        ) || {
          mobile: '',
          isMainCustomer: true,
          position: 'other',
          phones: [],
          courseRegister: []
        };

        const customersTemp = [
          mainCustomer,
          ...customers.filter(customer => !customer.isMainCustomer)
        ];

        let customerChildFirst = customersTemp.find(c => c.position === 'child');
        if (!customerChildFirst) {
          customersTemp.push( {
            customerId: new Date().getTime(),
            isMainCustomer: false,
            position: 'child',
            fullName: '',
            birthday: 0,
            courseRegister: [],
            isDataTemp: true,
          });
        }


        this.dataForm = {
          ...dataContact,
          contactSourceIds,
          groupIds,
          customers: customersTemp,
          productGroups: dataContact.groups.map(dataGroup => dataGroup.id),
        };
        if(this.stepOrder === 1) {
            this.getListCustomerOrder(this.dataForm.customers)
        }
        this.dataFormOld = JSON.stringify(this.dataForm);
        if(customersTemp.length > 0) {
          this.schoolId = customersTemp[0].schoolIds && customersTemp[0].schoolIds.length === 1 ? customersTemp[0].schoolIds[0] : ''
        }
      } else {

      }
    },
    async getProductComboList() {
      const respond = await ProductRepository.listAll({ limit: 100 });
      if (_.get(respond, 'success', false)) {
        const products = _.get(respond, 'data.products', []).map(product => {
          const productTemp = product;
          productTemp.idTemp = `product-${product.id}`;
          return productTemp;
        });
        const combos = _.get(respond, 'data.combos', []).map(combo => {
          const comboTemp = combo;
          comboTemp.idTemp = `combo-${combo.id}`;
          comboTemp.price = _.get(comboTemp, 'products', []).reduce(
            (accumulator, product) => {
              return accumulator + _.get(product, 'price', 0);
            },
            0
          );
          return comboTemp;
        });
        this.courseRegisters = [
          { header: 'Sản Phẩm' },
          ...products,
          { divider: true },
          { header: 'Combo' },
          ...combos
        ];
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    // checkDuplicateCustomer() {
    //   let checkObjectChild = {};
    //   let checkObjectNotChild = {};
    //   let statusChildError = false;
    //   this.dataForm.customers.forEach(dataCustomer => {
    //     if (!_.get(dataCustomer, 'isDeleted', false)) {
    //       const position = _.get(dataCustomer, 'position', 'other');
    //       if (position === 'child') {
    //         const keyChild = dataCustomer.birthday + '-' + _.trim(dataCustomer.fullName).toLocaleLowerCase();
    //         if (checkObjectChild[keyChild]) {
    //           statusChildError = true;
    //         }
    //         checkObjectChild[keyChild] = true;
    //       }
    //     }
    //   });
    //   if (statusChildError) {
    //     return 'Thông tin con bị trùng !!!';
    //   }
    //   return '';
    // },
    async getListCustomerOrder(listCustomers) {
      let customersTempId = []
      if(listCustomers.length) {
        listCustomers.forEach(item => {
          customersTempId.push(item.id)
        })
      }
      let listCustomerOrder = []
      const response =await ContactRepository.checkAccountContactNew({ 'customerIds':  customersTempId});
      if (_.get(response, 'success', false) && _.get(response, 'data', null)) {
        listCustomerOrder = _.get(response, 'data', [])
      }
      if(listCustomerOrder.length) {
        listCustomerOrder.forEach(item => {
          const customer =  listCustomers.find(data => data.id == item.id)
          if (customer) {
            customer.order = item.order ? this.formatDateVN(item.order) : ''
            customer.userName = item.userName
          }
        })
      }
    },
    async clickStep() {
      this.contentOrder.paidAmount = this.contentOrder.paidAmount << 0;
      this.getListCustomerOrder(this.dataForm.customers)
      if (this.stepOrder === 1) {
         return this.updateContact();
      }
    },
    async updateContact() {
      // let checkDuplicateCustomer = this.checkDuplicateCustomer();
      // if (checkDuplicateCustomer) {
      //   return this.$swal({
      //     type: 'error',
      //     title: 'Lỗi !',
      //     text: checkDuplicateCustomer
      //   });
      // }
      Object.assign(this.shippingAddress, {
        receiver: _.get(this.dataForm, 'customers[0].fullName', ''),
        phone: _.get(this.dataForm, 'customers[0].mobile', ''),
        email: _.get(this.dataForm, 'customers[0].email', ''),
        tinhId: _.get(this.dataForm, 'customers[0].tinhId') == 0 ? '' : _.get(this.dataForm, 'customers[0].tinhId'),
        huyenId: _.get(this.dataForm, 'customers[0].huyenId') == 0 ? '' : _.get(this.dataForm, 'customers[0].huyenId'),
        xaId: _.get(this.dataForm, 'customers[0].xaId') == 0 ? '' : _.get(this.dataForm, 'customers[0].xaId'),
        detailAddress: _.get(this.dataForm, 'customers[0].detailAddress', '')
      });
      if (JSON.stringify(this.dataForm) === this.dataFormOld) {
        this.stepOrder += 1;
        return;
      }
      const dataUser = TokenService.getUser() || {};

      const dataUpdate = {
        productGroups: _.get(this.dataForm, 'productGroups', []),
        statusId: _.get(this.dataForm, 'statusId', null),
        userId: _.get(this.dataForm, 'userId', null) || +_.get(dataUser, 'id', 0),
        userMarketingName: _.trim(this.dataForm.userMarketingName),
        contactSourceIds: _.get(this.dataForm, 'contactSourceIds', []),
        description: _.trim(this.dataForm.description),
        customers: [],
        schoolLevelId: _.get(this.dataForm, 'schoolLevelId', null),
        typeId: _.get(this.dataForm, 'typeId', null)
      };
      let checkErrorPhone = false;
      dataUpdate.customers = this.dataForm.customers.map(customer => {
        const customerTemp = { ...customer };
        const customerTempMobile = customerTemp.mobile;
        let customerId = _.get(customer, 'isNew', true)
          ? null
          : (customerId = _.get(customer, 'customerId', null));
        if (
          !_.get(customer, 'isMainCustomer', false) &&
          customerTemp.mobile &&
          customerTemp.mobile !== ''
        ) {
          if (!Array.isArray(customerTemp.phones)) {
            customerTemp.phones = [];
          }
          customerTemp.phones.unshift(customerTemp.mobile);
          customerTemp.mobile = '';
        }

        if (customerTemp.phoneSub) {
          if (customerTemp.phoneSub === customerTempMobile) {
            checkErrorPhone = true;
          }
          customerTemp.phones.push(customerTemp.phoneSub);
        }
        if(customerTemp.isMainCustomer && customerTempMobile && customerTemp.phones.includes(customerTempMobile)) {
          checkErrorPhone = true;
        }

        if (customerTemp.birthday < 1900) {
          customerTemp.birthday = null;
        }

        if (!customerTemp.positionTitle) {
          customerTemp.positionTitle = 'Khác';
        }

        if (
          _.get(customerTemp, 'isMainCustomer', false) &&
          !_.get(customerTemp, 'fullName', '')
        ) {
          customerTemp.fullName = _.get(customerTemp, 'mobile', '');
        }

        return {
          customerId,
          isDeleted: _.get(customerTemp, 'isDeleted', false),
          // isNew:  _.get(customer, 'isNew', true),
          mobile: _.get(customerTemp, 'mobile', ''),
          isMainCustomer: _.get(customerTemp, 'isMainCustomer', false),
          fullName: _.trim(customerTemp.fullName),
          birthday: _.get(customerTemp, 'birthday', null),
          birthdayDescription: _.trim(customer.birthdayDescription),
          email: _.get(customerTemp, 'email', ''),
          capability: _.trim(customerTemp.capability),
          position: _.get(customerTemp, 'position', 'other'),
          positionTitle: _.trim(customerTemp.positionTitle) || 'Khác',
          tinhId: _.get(customerTemp, 'tinhId', 0) || 0,
          huyenId: _.get(customerTemp, 'huyenId', 0) || 0,
          xaId: _.get(customerTemp, 'xaId', 0) || 0,
          detailAddress: _.trim(customerTemp.detailAddress),
          description: _.trim(customerTemp.description),
          phones: _.get(customerTemp, 'phones', []),
          productDescription: _.trim(customer.productDescription),
        };
      });
      if (checkErrorPhone) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Số điện thoại phụ không được giống số điện thoại chính',
        });
      }
      if(!dataUpdate.typeId) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Contact chưa thuộc loại hình nào!'
        });
      }
      this.loading = this.$loading.show();
      const response = await ContactRepository.update(
        dataUpdate,
        this.$route.params.id
      );
      this.loading.hide();
      if (response.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      } else if (_.get(response, 'data.isExist', false)) {
        this.$swal({
          title: 'Cập nhật contact không thành công, Số điện thoại đã tồn tại!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Xem contact',
          closeOnConfirm: false,
          cancelButtonText: 'Huỷ Bỏ'
        }).then(result => {
          if (result.value) {
            return this.$router.push({
              name: 'ContactDetail',
              params: {
                id: _.get(response, 'data.contactId', null)
              }
            });
          }
        });
      } else {
        await this.getContactDetail();
        this.stepOrder = 2;
      }
    },
    async beforeCreate() {
      const valid =await this.$refs.validator.validate();
      if(valid) {
      let objectCheckProducts = {};
      const productsTemp = [];
      let indexProductsTemp = 0;

      let contentOrderTutor = this.$refs.child.orderT.concat(this.$refs.child.orderGS)
      if(_.isEmpty(contentOrderTutor)) {
        this.$swal.fire('Chưa có sản phẩm nào!')
        return
      }
      const checkOrder = _.some(contentOrderTutor, (item) => {
          return item.customerId === '' || item.orderType === '' || item.productId === ""
      });
      if(checkOrder) {
        this.$swal.fire('Thông tin đơn hàng bị thiếu thông tin. Vui lòng kiểm tra lại!');
        return
      }

      contentOrderTutor.forEach(product => {
        const idTemp = product.productId + '_' + product.customerId;
        const indexTemp = objectCheckProducts[idTemp];
        if (indexTemp == null) {
          objectCheckProducts[idTemp] = indexProductsTemp;
          indexProductsTemp++;
          productsTemp.push({ ...product });
        } else {
          productsTemp[indexTemp].quantity = +productsTemp[indexTemp].quantity + parseInt(product.quantity);
        }
      });
      // this.contentOrder.totalPrice = productsTemp.reduce((accumulator, product) => {return accumulator + _.get(product, 'price', 0) * _.get(product, 'quantity', 0)}, 0) || 0
      this.contentOrder.totalPrice = contentOrderTutor.reduce((accumulator, product) => {
        return accumulator + parseInt(_.get(product, 'intoMoney', 0))
      }, 0) || 0
      // End Combine the same products and customers
      this.contentOrder.products = productsTemp;
      let firstIndexParent = -1;
      let fullNameParent = '';
      const contentOrderUpdate = {
        description: _.trim(this.contentOrder.description),
        paymentType: this.contentOrder.paymentType,
        paidAmount: !this.contentOrder.paidAmount
          ? 0
          : Number(this.contentOrder.paidAmount),
        totalPrice: !this.contentOrder.totalPrice
          ? 0
          : Number(this.contentOrder.totalPrice),
        noteSortClass: _.trim(this.contentOrder.noteSortClass),
      };
      contentOrderUpdate.products = contentOrderTutor.map(product => {
        const productTemp = { ...product };
        const productArray = productTemp.productId.split('-');
        const customerChild = this.childCustomers.find(
          customer => customer.customerId == product.customerId
        );
        return {
          productId: +productArray[1],
          productType: productArray[0],
          quantity: +product.quantity,
          customerId: +product.customerId,
          // price: product.price
          price: Math.round(+product.intoMoney / +product.quantity),
          intoMoney: +product.intoMoney,
          orderType: +product.orderType,
          activeType: +product.activeTypeOrder,
          activeDate: product.activeDate,
        };
      });
      const shippingAddressUpdate = {
        receiver: _.trim(this.shippingAddress.receiver),
        phone: _.get(this.shippingAddress, 'phone', ''),
        email: _.get(this.shippingAddress, 'email', ''),
        tinhId: _.get(this.shippingAddress, 'tinhId', ''),
        huyenId: _.get(this.shippingAddress, 'huyenId', ''),
        xaId: _.get(this.shippingAddress, 'xaId', ''),
        detailAddress: _.trim(this.shippingAddress.detailAddress)
      };
      const dataUpdate = {
        contactId: this.$route.params.id,
        paymentType: _.get(contentOrderUpdate, 'paymentType', 'BANK'),
        description: _.trim(contentOrderUpdate.description),
        paidAmount: +_.get(contentOrderUpdate, 'paidAmount', 0),
        totalPrice: +_.get(contentOrderUpdate, 'totalPrice', 0),
        products: _.get(contentOrderUpdate, 'products', []),
        shippingAddress: shippingAddressUpdate,
        noteSortClass: _.trim(contentOrderUpdate.noteSortClass || '' ),
        schoolIds: this.schoolId ? [this.schoolId] : [],
      };

      this.dataUpdate = dataUpdate
        const dataTimeOrderHT = dataUpdate.products.map((s) => {
          const foundProduct = _.find(this.$refs.child.orderHT, o2 => s.productId === o2.id && o2.productType !== 'GIA_SU')
          let findProduct = this.courseRegisters.find(item => item.id == s.productId)
          let checkName = findProduct.name.toLowerCase().indexOf('gia hạn') >= 0
          if(foundProduct && this.$refs.child.statusDepositOne) {
            return {
              ...s,
              listEndDate:foundProduct.endMonth || foundProduct.numberOfSection,
              checkDeposit: true,
              endMonth: foundProduct.endMonth
            }
          }else if(foundProduct && this.$refs.child.statusDepositTwo && !checkName){
              const newDate = moment().add(foundProduct.quantity, 'months');
            return {
              ...s,
              listEndDate: newDate.format('DD/MM/YYYY'),
              checkDeposit: false,
              quantityOrderHT: foundProduct.quantity,
              endMonth:  foundProduct.endMonth
            }
          }else if(foundProduct && this.$refs.child.statusDepositTwo && checkName){
            return {
              ...s,
              listEndDate: foundProduct.quantity,
              checkDeposit: true,
              quantityOrderHT: foundProduct.quantity,
              endMonth: foundProduct.quantity
            }
          } else {
            return {
              ...s,
              listEndDate: null,
              endMonth: foundProduct && foundProduct.endMonth ? foundProduct.endMonth : ''
            }
          }
          // if(foundProduct && !this.$refs.child.statusDepositTwo) {
          //   return {
          //     ...s,
          //     listEndDate: foundProduct.endMonth,
          //     checkDeposit: true
          //   }
          // } else if(foundProduct && this.$refs.child.statusDepositTwo){
          //   const newDate =  moment().add(foundProduct.quantity, 'months');
          //   return {
          //     ...s,
          //     listEndDate: newDate.format('DD/MM/YYYY'),
          //     checkDeposit: false
          //   }
          // }else {
          //   return {
          //     ...s,
          //     listEndDate: null
          //   }
          // }
        })
      this.loading = this.$loading.show()
      const arrayDataProduct = [608,609,610,611,732]
      let res;
      const isUpdate = dataUpdate.products.every(item => arrayDataProduct.includes(item.productId));
        if(isUpdate){
          res = await ContactRepository.checkCustomerBeforeCreateV2(dataUpdate.products)
        }else {
         res = await ContactRepository.checkCustomerBeforeCreate(dataUpdate.products)
        }
      if (res.success) {
        // dataUpdate.contactId = this.contactId
          const productId = []
          dataUpdate.products.forEach(item => {
              productId.push(item.productId)
          })
        const responseProductLearnType = await OrderRepository.getListProductLearnType({ productIds: productId })
          if(responseProductLearnType.success) {
              this.listProductLearnType = responseProductLearnType.data
          }
        dataUpdate.listEndDate = {};
        let response;
          if(isUpdate) {
            response = await OrderRepository.getEndDateV2(dataUpdate)
        }else {
            response = await OrderRepository.getEndDate(dataUpdate)
        }

        this.loading.hide()
        if (response.success) {
          this.checkEndDate = true;
          dataUpdate.products.forEach((item, key) => {
            if(typeof dataUpdate.listEndDate[item.customerId] == 'undefined') {
              dataUpdate.listEndDate[item.customerId] = {}
            }

            // let endDateObject = response.data[item.customerId][item.productId];
            let endDateRes = response.data[item.customerId][item.productId];

            if(endDateRes.toUpperCase() === 'INVALID DATE') {
              this.checkEndDate = false;
              // return;
            }
            if(item.productId){
              const foundProduct = _.find(dataTimeOrderHT, productId => productId.productId == item.productId)
              // let findProduct = this.courseRegisters.find(s => s.id == item.productId)
              // let checkName = findProduct.name.toLowerCase().indexOf('gia hạn') < 0
              if(foundProduct && foundProduct.listEndDate && response.data[item.customerId][item.productId] != 'Invalid date') {
                if(foundProduct.activeType === 3 && !foundProduct.checkDeposit) {
                  const endDate = moment(foundProduct.activeDate).add(foundProduct.quantityOrderHT, "months").format('DD/MM/YYYY');
                  dataUpdate.listEndDate[item.customerId][item.productId] = {end_date: endDate, checkDeposit: foundProduct.checkDeposit};
                }else {
                  dataUpdate.listEndDate[item.customerId][item.productId] = {end_date: foundProduct.listEndDate, checkDeposit: foundProduct.checkDeposit};
                }
              }else {
                  dataUpdate.listEndDate[item.customerId][item.productId] = {
                    end_date: response.data[item.customerId][item.productId],
                    checkDeposit: false
                  };
              }
            }
          })
          this.dataDialog = {
            ...dataUpdate,
            // products: _.get(response, 'data', []),
            shippingAddress: {
              ...this.shippingAddress
            }
          }
          if(this.$refs.child.priceDeposit && (this.$refs.child.statusDepositOne || this.$refs.child.statusDepositTwo)) {
            this.dataDialog.restPrice = (Number(this.$refs.child.priceDeposit))
          }
          this.createDialog = true
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(response, 'message', '')
          })
        }
      } else {
        this.loading.hide()
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        })
      }
      }
    },
    closeModal() {
      this.createDialog = false
    },
    backToPrevStep() {
      this.$router.push({name: 'UpdateContactInfo', params: { id: this.$route.params.id }});
    },
    async checkVersionUser() {
      const res = await OrderRepository.getVersionOrder()
      if(res && res.success) {
        this.versionUser = res.data.orderVersion
      }
    },
  }
};
</script>
<style lang="sass">
  .active-step-3
    .sort-order
      order: 2

</style>
